import { render, staticRenderFns } from "./AssesmentInfo.vue?vue&type=template&id=7ebf83e2&scoped=true"
import script from "./AssesmentInfo.vue?vue&type=script&lang=js"
export * from "./AssesmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebf83e2",
  null
  
)

export default component.exports